import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { MONEY_COLOR } from '#client/constants/transaction';
import { formatMoneyInOutUpdate } from '#client/utils/currency';

export default function Money({
  amount,
  direction,
  isPayment = false,
  color = MONEY_COLOR.PRIMARY
}) {
  return (
    <Text
      color={color}
      size="xl"
      weight="medium"
      whiteSpace="nowrap"
    >
      {formatMoneyInOutUpdate(direction, amount, isPayment)}
    </Text>
  );
}

Money.propTypes = {
  amount: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  isPayment: PropTypes.bool,
  color: PropTypes.string
};
